import React from 'react'

import TopicList from 'app/PelatihanMandiriPage/pages/TopicList'
import PageHeader from 'app/PelatihanMandiriPage/components/PageHeader'
import { shouldHideNav } from 'app/PelatihanMandiriPage/helper'
import { useScreenSizeContext } from 'utils/hooks/context/useScreenSizeContext'
import { DesktopLayout } from 'components/Layout/Desktop/DesktopLayout'

const DaftarTopikPage = () => {
  const { isDesktop } = useScreenSizeContext()

  if (isDesktop) {
    return <DesktopLayout submenu={<TopicList isDesktop={isDesktop} />} />
  }

  return <TopicList />
}

DaftarTopikPage.layoutOpts = {
  hasHeader: !shouldHideNav(),
  className: 'text-default bg-gray-10',
  header: PageHeader,
  enableDesktopLayout: true,
}

export default DaftarTopikPage
